// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { JSX, PropsWithChildren } from 'react';

// styles
import styles from './PageTransition.module.scss';

type PageTransitionProps = {
  fallbackSpacing?: boolean;
};

const PageTransition = ({
  children,
  fallbackSpacing = false,
}: PropsWithChildren<PageTransitionProps>): JSX.Element => {
  return (
    <div className={`${styles.page_transition} ${fallbackSpacing ? styles.fallback_spacing : ''}`}>
      {children}
    </div>
  );
};

export default PageTransition;
